export default "__VITE_ASSET__CqZD2kZV__"